// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundBlock_wrapper__LxBhb","description":"NotFoundBlock_description__vzcye","title":"NotFoundBlock_title__PxjRv"};